// The label at the top left of an ASK answer's wide window (client QA, 10 Oct):
// the LLM's name and version, e.g. "Gemini 3.1 Flash Lite", in place of the old
// "ASKMYLLM" badge. From the server's answeredBy { name, version }, or else
// from the answer's own "— <name> (<version>)" signature.

const UPPER = new Set(["gpt", "ai", "vl", "fp8", "fp4"]);

// "gemini-3.1-flash-lite" -> "Gemini 3.1 Flash Lite"; "meta-llama/Llama-3.3-70B-Instruct-Turbo"
// -> "Llama 3.3 70B Instruct Turbo"; "claude-haiku-4-5" -> "Claude Haiku 4.5".
export function prettyVersion(version) {
  const last = String(version || "").split("/").pop();
  const joined = last.replace(/(^|[-_ ])(\d)[-_](\d)(?=$|[-_ ])/g, "$1$2.$3");
  return joined
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((w) => (UPPER.has(w.toLowerCase()) ? w.toUpperCase() : /^[a-z]/.test(w) ? w[0].toUpperCase() + w.slice(1) : w))
    .join(" ");
}

export function llmLabel(name, version) {
  const n = String(name || "").trim();
  const v = prettyVersion(version);
  if (!v) return n;
  if (!n) return v;
  const lowV = v.toLowerCase();
  if (lowV.startsWith(n.toLowerCase())) return n + v.slice(n.length);
  // The name ends with the start of the version ("Meta Muse Glimmer" + "Muse Glimmer 30B").
  const words = n.split(/\s+/);
  for (let i = 0; i < words.length; i++) {
    const tail = words.slice(i).join(" ");
    if (lowV.startsWith(tail.toLowerCase() + " ") || lowV === tail.toLowerCase()) return `${words.slice(0, i).join(" ")} ${v}`.trim();
  }
  return `${n} ${v}`;
}

// From answeredBy, else the signature line at the end of the answer.
export function llmLabelFor(data, text) {
  const by = data && data.answeredBy;
  if (by && (by.name || by.version)) return llmLabel(by.name, by.version);
  const m = /\n\s*—\s*([^()\n]+?)\s*(?:\(([^)\n]+)\))?\s*$/.exec(String(text || ""));
  return m ? llmLabel(m[1], m[2]) : "";
}
